<div class="helper-banner">
  <div class="helper-banner__icon">
    <i class="fa-solid fa-circle-info"></i>
  </div>
  <div class="helper-banner__content">
    <ng-content select="[helper-content]"></ng-content>
  </div>
</div>
